import { withOptions } from "./invoke";
import type { AnyFunction, GetterHandler } from "./private.types";
import type { Unset, ExtendedPromise, InvocationOptions, SetOptions } from "./public.types";
/*                                       */
import { addListener, getStoreType, updateStoreValue } from "./store";

/**
 *
 */
export const applyHandler = ((store, _, config) => {
  return (thisArg: unknown, argArray: unknown[]): unknown => {
    const [, invokeSignalListeners, invokeQueueHandler] = config;

    /*                                */
    if (store.isEvent) {
      return invokeSignalListeners(thisArg, store, argArray);
    }

    if (store.isNs) {
      throw Error(
        `Unexpected invocation of ${
          store.path
        }. Already initialized as namespace with ${Object.keys(store.members)}`,
      );
    }

    /*                                      */
    store.isFunc = true;
    return invokeQueueHandler(thisArg, store, argArray);
  };
}) satisfies GetterHandler;

/**
 *
 */
export const withHandler = ((store) => (options: InvocationOptions) =>
  withOptions(store.ready, store, options)) satisfies GetterHandler;

/**
 *
 */
export const callHandler = ((store, target, config) =>
  (thisArg: unknown, ...argArray: unknown[]): unknown =>
    applyHandler(store, target, config)(thisArg, argArray)) satisfies GetterHandler;

/**
 *
 */
export const setHandler = ((store, target) =>
  (value: unknown, options?: SetOptions): Unset =>
    updateStoreValue(store, target, value, options)) satisfies GetterHandler;

/**
 *
 */
export const isSetHandler = ((store) => {
  return !!store.handler;
}) satisfies GetterHandler;

/**
 *
 */
export const thenHandler = ((store) =>
  (callback: AnyFunction): ExtendedPromise<unknown> => {
    const res = store.ready.then(callback) as ExtendedPromise<unknown>;

    return res;
  }) satisfies GetterHandler;

/**
 *
 */
export const onHandler = ((store) =>
  (listener: AnyFunction): Unset =>
    addListener(store, listener)) satisfies GetterHandler;

/**
 *
 */
export const emitHandler = ((store, t, config) =>
  function (this: unknown, detail: unknown) {
    return config[1](this, store, [detail]);
  }) satisfies GetterHandler;

/**
 *
 */
export const toStringHandler = ((store, target) => (): string => {
  const members = Object.keys(store.members);
  const { isEvent, isNs, isFunc, isReady, isSig } = store;
  const isWrapper = !isEvent && !isFunc && !isNs && !isSig;

  return `[${getStoreType(store)}: ${(store.handler ?? target).name}${
    isWrapper
      ? ""
      : ` (${
          /*                                         */
          isEvent
            ? `listeners: ${store.listeners.length}`
            : isFunc
            ? `pending invocations: ${store.invocations.length}, isSet: ${!!store.handler}`
            : `members: ${members.join()}, ready: ${!!isReady}`
        })`
  }]`;
}) satisfies GetterHandler;
